<!--html-->
<template src="../assets/html/questionFeedback.html"></template>
<!--css引用-->
<style src="../assets/css/questionFeedback.css" lang="css"></style>
<!--js脚本-->
<script>
  import { Message } from 'element-ui';
  import { MessageBox } from 'element-ui';
  import C from "../utils/C";

  export default {
    name: 'QuestionFeedback',
    data () {
      var that = this
      return {
        mafawu_back:"https://img.hatcloud.cn/20163316_1638536982755985707.png?e=2269256565&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:9dUbCFyqI1OzE8bUlQMdDrIj-_M=",

        funcInfo:"",//输入功能信息
        //网页内容
        tabImageUrl:"",//图片
        faqList:[],
        contactInfo:"",//底部信息

        hadSubmitFuncInfo:false,//是否提交了信息
        submitSuccessShow:false,//提交成功弹窗

        faqQQ:"",//qq号码

        isAndroid:false,
      }
    },
    mounted() {
      ///获取数据
      //先注册当前的url,通过后端
      var that = this
      this.$netGo.getFaqList().then(function(result){
        console.log(result)
        // alert(result)
        ///////设置数据
        that.tabImageUrl = result.tabImageUrl
        ///////设置数据
        that.faqList = result.faqList
        //底部信息
        that.contactInfo = result.contactInfo

        that.faqQQ = result.faqQQ
      })

      //设置数据为空
      this.$set(this,"funcInfo", "");


      // 屏幕宽
      this.screenWidth = window.screen.width
      // 屏幕高
      this.screeHeight = window.screen.height

      console.log("屏幕宽度,screenWidth:"+this.screenWidth+",screeHeight:"+this.screeHeight)
      var that = this
      //修改尺寸
      if (process.client) {
        window.onresize = function () {
          return (() => {
            // 屏幕宽
            that.screenWidth = document.body.clientWidth
            // 屏幕高
            that.screeHeight = document.body.clientHeight

            console.log("屏幕尺寸改变：" + that.screenWidth + "," + that.screeHeight)
          })()
        }
      }


      let systemParam = C.getSystemInfo();
      if (systemParam && systemParam.deviceType) {
        let deviceType = systemParam.deviceType;
        console.log("deviceType:"+deviceType)
        this.isAndroid = (deviceType == "android")
      }
    },
    methods:{
      submitFuncInfo:function(){////提交需求
        var funcInfo = this.$data.funcInfo.trim()
        //必须有数据
        if(funcInfo == undefined || funcInfo == null || funcInfo == ""){
          this.funcInfo = ""
          alert("输入数据不能为空.")
          return
        }
        //定义数据格式为字符串
        var that = this
        this.$netGo.addFunctionMore(funcInfo).then(function(result){
          // alert("感谢提交成功，我们将会及时核验功能!")
          that.funcInfo = ""
          ///加载成功标示
          that.hadSubmitFuncInfo = true

          // //定时器显示成功
          // that.submitSuccessShow = true
          // setTimeout(function () {
          //   //关闭
          //   that.submitSuccessShow = false
          // },2000)
        })
      },
      copyQQ:function (event){
        // alert("内容已复制到剪切板！")
        Message({
          message:"内容已复制到剪切板！",
          type:"success",
          center:true,
          offset:this.screeHeight/2
        });
      },
      onError:function (event){
        Message({
          message:"抱歉,复制失败！",
          type:"error",
          center:true,
          offset:this.screeHeight/2
        });
      },
      //跳转问题详情
      gotoProblemDetail:function (event) {
        var id = event.currentTarget.dataset.id;
        //当前域名
        var domain = document.domain;
        var url ='https://'+domain+'/problemDetail?id='+id
        window.location.href=url;
      },

      close(event){///重新加载页面
        console.log("点击了,popToApp")
        if (window.android) {
          window.android.popToApp();
        }
      },
      showStatus(event){///重新加载页面
        console.log("点击了,showStatus")
        if (window.android) {
          window.android.showStatus();
        }
      },
      hideStatus(event) {///重新加载页面
        console.log("点击了,hideStatus")
        if (window.android) {
          window.android.hideStatus();
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/QuestionFeedback.vue